import React from "react";
import { useNavigate } from "react-router-dom";
import logoImg from "../Images/logo.png";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaChevronRight,
} from "react-icons/fa";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-dark text-light pt-5">
      <div className="container">
        <div className="row gy-4">

          {/* LOGO + ABOUT */}
          <div className="col-lg-3 col-md-6">
            <img
              src={logoImg}
              alt="Dellson Logo"
              style={{
                height: "80px",
                cursor: "pointer",
                objectFit: "contain",
              }}
              onClick={() => navigate("/")}
            />

            <h6 className="text-primary fw-bold mt-2">
              Trusted Pumps & Motors Supplier
            </h6>

            <p className="text-secondary">
              Premium pumps and motors built for performance, durability,
              and long-lasting efficiency at competitive prices.
            </p>
          </div>

          {/* CONTACT INFO */}
          <div className="col-lg-3 col-md-6">
            <h5 className="fw-bold mb-3">Contact Info</h5>

            <p className="mb-2">
              <FaMapMarkerAlt className="me-2 text-primary" />
              Dellson pumps & pipes industies - Ahmdabad
               Near - mandi  samiti Bindki Kuwar Pur road , Bindki
            </p>

            <p
              className="mb-2"
              style={{ cursor: "pointer" }}
              onClick={() => (window.location.href = "tel:09415039147")}
            >
              <FaPhoneAlt className="me-2 text-primary" />
              +91 94150 39147
            </p>

            <p
              className="mb-2"
              style={{ cursor: "pointer" }}
              onClick={() =>
                (window.location.href =
                  "mailto:dellsonpumpsandpipes@gmail.com")
              }
            >
              <FaEnvelope className="me-2 text-primary" />
              dellsonpumpsandpipes@gmail.com
            </p>
          </div>

          {/* QUICK LINKS */}
          <div className="col-lg-3 col-md-6">
            <h5 className="fw-bold mb-3">Quick Links</h5>

            <p
              className="mb-2"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/")}
            >
              <FaChevronRight className="me-2 text-primary" />
              Home
            </p>

            <p
              className="mb-2"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/about")}
            >
              <FaChevronRight className="me-2 text-primary" />
              About Us
            </p>

            <p
              className="mb-2"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/product")}
            >
              <FaChevronRight className="me-2 text-primary" />
              Our Product
            </p>

            <p
              className="mb-2"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/contact")}
            >
              <FaChevronRight className="me-2 text-primary" />
              Contact Us
            </p>
          </div>

          {/* IMAGE GRID – 6 DIFFERENT IMAGES */}
          <div className="col-lg-3 col-md-6">
            <div className="row g-2">
              {[
                "https://img2.exportersindia.com/product_images/bc-full/2020/1/6902836/submersible-pumpset-1580120312-5264225.jpeg",
                "https://tse3.mm.bing.net/th/id/OIP.vVvveu3C9h_uAbycCP6-XwHaGy?pid=Api&P=0&h=180",
                "https://metalexponents.com/wp-content/uploads/2020/11/PVC-Pipes.jpg",
                "https://www.ewarehouse.my/image/cache/data/all_product_images/product-7592/hdpe-pipe1-700x700.jpg",
                "https://tse1.mm.bing.net/th/id/OIP.qhLhwrzVv0bQ0sQaoAObtwHaHa?pid=Api&P=0&h=180",
                "https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/Articles/how-to-cut-pvc-pipe-step-9.jpg",
              ].map((img, i) => (
                <div className="col-4" key={i}>
                  <img
                    src={img}
                    alt="Pump motor gallery"
                    className="img-fluid rounded"
                    style={{
                      height: "70px",
                      objectFit: "cover",
                    }}
                  />
                </div>
              ))}
            </div>
          </div>

        </div>

        <hr className="border-secondary mt-4" />
<div className="text-center text-secondary pb-3">
  <p className="mb-0">
    © 2026 Dellson. All Rights Reserved. Developed  By 
    <span style={{cursor:'pointer'}}
     onClick={() => window.open('https://dectwinservices.com', '_blank')}> Dectwin Services Pvt Ltd</span>
  </p>
</div>

      </div>
    </footer>
  );
};

export default Footer;
